module.exports = __webpack_public_path__ + "static/img/PrestationSoin2.2aa59e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PrestationSoin2.jpg
// module id = MmJ9
// module chunks = 1